import React, { useState } from "react";
import { Button, Text } from "@jsq/ds/core";
import { NocPaymentDetailsModal } from "./NocPaymentDetailsModal";
import * as styles from "./styles_vanilla.css";
import { type NocCorrectionViewModel } from "./types";

export type NocCorrectionsListProps = {
  corrections: NocCorrectionViewModel[];
};

export const NocCorrectionsList: React.FC<NocCorrectionsListProps> = ({ corrections }) => {
  const [selectedPaymentId, setSelectedPaymentId] = useState<string | null>(null);

  return (
    <>
      {corrections.map((correction) => (
        <li key={correction.paymentId} className={styles.warningListItem}>
          <Text variant="strong-md" asSpan>
            {"Payment ID: "}
          </Text>
          <Button
            variant="link"
            isInline
            displayAsLink
            onClick={() => setSelectedPaymentId(correction.paymentId)}
            data-testid={`noc-payment-link-${correction.paymentId}`}
          >
            {correction.paymentId}
          </Button>
          {correction.dateReceived && (
            <div>
              <Text variant="strong-md" asSpan>
                {"Date received: "}
              </Text>
              <Text variant="regular-md" asSpan>
                {correction.dateReceived}
              </Text>
            </div>
          )}
          {correction.correctionDetails.length > 0 && (
            <ul className={styles.nocCorrectionDetailsList}>
              {correction.correctionDetails.map((detail) => (
                <li key={detail.label} className={styles.nocCorrectionDetailItem}>
                  <Text variant="strong-md" asSpan>{`${detail.label}: `}</Text>
                  {detail.value}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
      {selectedPaymentId != null && (
        <NocPaymentDetailsModal
          paymentId={selectedPaymentId}
          onClose={() => setSelectedPaymentId(null)}
        />
      )}
    </>
  );
};
